import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { ThemeProvider, CssBaseline } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Layout from "./components/layout/Layout";
import Activities from './pages/Activities';
import TechnologiesDetails from './pages/Technologies';
import Categories from './pages/Categories';
import NotFound from './pages/NotFound';
import UnderConstruction from './pages/UnderConstruction';
import AssignActivity from './pages/AssignActivity';
import MyActivity from './pages/MyActivity';
import ProtectedRoute from "./ProtectedRoute";

const theme = createTheme();

const App: React.FC = () => {

    const { instance, inProgress, accounts } = useMsal();
    const [ready, setReady] = useState(false);

    useEffect(() => {

        const init = async () => {

            // 🔥 wait until MSAL finished redirect handling
            if (inProgress !== "none") return;

            // if already logged in
            if (accounts.length > 0) {
                instance.setActiveAccount(accounts[0]);
                setReady(true);
                return;
            }

            // 🔥 only trigger login when safe
            await instance.loginRedirect(loginRequest);
        };

        init();

    }, [inProgress, accounts, instance]);

    if (!ready) return <div>Loading...</div>;

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Router>
                    <Layout>
                        {(sidebarOpen: boolean) => (
                            <Routes>

                                {/*<Route path="/" element={<Navigate to="/dashboard" replace />} />*/}
                                {/*<Route path="/dashboard" element={<UnderConstruction title="Dashboard" />} />*/}
                                <Route path="/" element={<Navigate to="/my-activity" replace />} />
                                {/* ADMIN ONLY */}
                                <Route
                                    path="/technologies"
                                    element={
                                        <ProtectedRoute allowAdmin>
                                            <TechnologiesDetails />
                                        </ProtectedRoute>
                                    }
                                />

                                <Route
                                    path="/categories"
                                    element={
                                        <ProtectedRoute allowAdmin>
                                            <Categories />
                                        </ProtectedRoute>
                                    }
                                />

                                {/* ADMIN + MANAGER */}
                                <Route
                                    path="/activities"
                                    element={
                                        <ProtectedRoute allowAdmin allowManager>
                                            <Activities sidebarOpen={sidebarOpen} />
                                        </ProtectedRoute>
                                    }
                                />

                                <Route
                                    path="/assign-activity"
                                    element={
                                        <ProtectedRoute allowAdmin allowManager>
                                            <AssignActivity sidebarOpen={sidebarOpen} />
                                        </ProtectedRoute>
                                    }
                                />

                                {/* ALL USERS */}
                                <Route path="/my-activity" element={<MyActivity />} />

                                <Route path="*" element={<NotFound />} />

                            </Routes>
                        )}
                    </Layout>
                </Router>
            </LocalizationProvider>

        </ThemeProvider>
    );
};

export default App;